/* Import reducers */
import authError from './authError'
import chatError from './chatError'
import serviceRequest from './serviceRequest'
import {combineReducers} from 'redux'

/**
 * Notices Reducer index.
 * Combines reducers into a single reducer.
 */
export default combineReducers({
	authError,
	chatError,
	serviceRequest
})
